import {
  GET_TRANSACTION_LIST_REQUEST,
  GET_TRANSACTION_LIST_SUCCESS,
  GET_TRANSACTION_LIST_FAILURE
} from '../constants/transactionConstants';

// Get Transaction List Actions
export const getTransactionListRequest = (params) => ({
  type: GET_TRANSACTION_LIST_REQUEST,
  payload: params
});

export const getTransactionListSuccess = (data) => ({
  type: GET_TRANSACTION_LIST_SUCCESS,
  payload: data
});

export const getTransactionListFailure = (error) => ({
  type: GET_TRANSACTION_LIST_FAILURE,
  payload: error
});